import { useGateValue } from '@statsig/react-bindings';
import type { PropsWithChildren } from 'react';

export interface FeatureGateProps {
  readonly id: string;
}

const FeatureGate = ({ children, id }: PropsWithChildren<FeatureGateProps>) => {
  const isEnabled = useGateValue(id);

  if (!isEnabled) {
    return null;
  }

  return children;
};

export default FeatureGate;
